import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import styles from './FacebookLoginButton.scss';

export default function FacebookLoginButton(props) {

	useEffect(() => {
		if (typeof window.fbAsyncInit === 'function') {
			window.fbAsyncInit();
		}
	}, [window.FB])

	return (
		<div
			className={props.buttonClassName}
			data-size={props.size}
			data-button-type={props.buttonType}
			data-layout={props.layout}
			data-auto-logout-link={props.autoLogoutLink}
			data-use-continue-as={props.useContinueAs}
			data-width={props.width}
			data-scope={props.scope}>
		</div>
	)
}

FacebookLoginButton.propTypes = {
	buttonClassName: PropTypes.string,
	size: PropTypes.string,
	facebookScope: PropTypes.string,
	buttonType: PropTypes.string,
	layout: PropTypes.string,
	autoLogoutLink: PropTypes.string,
	useContinueAs: PropTypes.string,
	width: PropTypes.string,
	scope: PropTypes.string,
}
FacebookLoginButton.defaultProps = {
	buttonClassName: `${styles.fbLoginButton} fb-login-button`,
	size: "large",
	buttonType: "continue_with",
	layout: "default",
	autoLogoutLink: "false",
	useContinueAs: "true",
	scope: "public_profile,email",
	width: "100%"
}